// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_af9705b7","list":"_ba8410c6","item":"_5e12ae51"};